import Modal from "../../ReusableComponents/Modal"
import { LeadsCallHistoryTable } from "./leadsCallsHistory"



export const PopupCallHistory = ({open,onClose,data})=>{


    return(
        <Modal
            header={"Call History"}
            open={open}
            onClose={onClose}
            contentStyle={{ width: "940px", height: "auto", borderRadius: "10px" }}
        >
            <LeadsCallHistoryTable state={{lead_id : data.id}}/>
        </Modal>
    )
}